module.exports = __webpack_public_path__ + "img/9788937821578.fef12f11.jpg";